'use client';

import { CustomHeaderContact } from '@/components/CustomLayout/CustomHeaderContact';
import { LayoutContext } from '@/contexts/LayoutContext';
import { LayoutReducerActionType } from '@/types/layout';
import { useContext, useEffect } from 'react';

export interface ICMSPageCustomHeaderProps {
  pageTitle?: string;
}

export const CMSPageCustomHeader = ({ pageTitle }: ICMSPageCustomHeaderProps) => {
  const { context: layoutContext, dispatch: layoutDispatch } = useContext(LayoutContext);
  const { contactItems } = layoutContext || {};

  const hasCustomHeaderContacts = !!contactItems
    ?.filter((contact) => contact.custom_item)
    .some((contact) => contact.page_title_contains);

  const customContactItems = [];
  let customMatch = false;

  if (pageTitle && hasCustomHeaderContacts) {
    contactItems
      ?.filter((contact) => (contact.custom_item && contact.page_title_contains) || contact.always_include)
      ?.forEach((contact) => {
        if (contact.always_include) {
          customContactItems.push(contact);
          return;
        }

        const matchTitleContains =
          contact.page_title_contains
            .split(',')
            .map((title) => title.toLowerCase().trim())
            .filter(Boolean) || [];

        const hasAnyFilter = matchTitleContains.length > 0;

        const match =
          hasAnyFilter &&
          (matchTitleContains.length === 0 ||
            matchTitleContains.some((title) => pageTitle.toLowerCase().includes(title)));

        if (match) {
          customContactItems.push(contact);
          customMatch = true;
        }
      });
  }

  const defaultContactItem = customContactItems.find((contact) => contact.default);

  useEffect(() => {
    if (!customMatch || !defaultContactItem) return;
    if (layoutContext?.defaultContactItem?.title === defaultContactItem.title) return;

    layoutDispatch({
      type: LayoutReducerActionType.updateDefaultContactItem,
      payload: defaultContactItem,
    });
  }, [customMatch, defaultContactItem, layoutContext?.defaultContactItem, layoutDispatch]);

  if (!pageTitle || !hasCustomHeaderContacts) {
    return null;
  }

  return customMatch && customContactItems.length > 0 ? (
    <CustomHeaderContact contact_items={customContactItems} />
  ) : null;
};
